import React, { useEffect, useCallback } from 'react';
import { apiHolder as api, apis, conf, inWindow, surveySpaceCode_electron, surveySpaceCode_web_new, surveySpaceCode_web_old, surveySpaceCode_dev, } from 'api';
import debounce from 'lodash/debounce';
const advertApi = api.api.requireLogicalApi(apis.advertApiImpl);
const systemApi = api.api.getSystemApi();
const storeApi = api.api.getDataStoreApi();
const isWebmail = inWindow() && conf('profile') ? conf('profile').toString().includes('webmail') : false;
const isProd = conf('stage') === 'prod';
const SURVEY_COUNT_PREFIX = 'survey_space_count_';
const MAX_POPUP_COUNT = 2;
const getPopupCount = (surveyId) => {
    try {
        const data = storeApi.getSync(`${SURVEY_COUNT_PREFIX}${surveyId}`);
        return (data === null || data === void 0 ? void 0 : data.suc) && (data === null || data === void 0 ? void 0 : data.data) ? parseInt(data.data, 10) : 0;
    }
    catch (_a) {
        return 0;
    }
};
const incrementPopupCount = (surveyId) => {
    try {
        const count = getPopupCount(surveyId);
        storeApi.putSync(`${SURVEY_COUNT_PREFIX}${surveyId}`, String(count + 1));
    }
    catch (error) {
        console.error('[SurveySpace] 增加调查次数失败', error);
    }
};
const getSpaceCode = () => {
    let curSpaceCode = null;
    if (process.env.BUILD_ISEDM) {
        curSpaceCode = null;
    }
    else if (process.env.BUILD_ISELECTRON) {
        curSpaceCode = surveySpaceCode_electron;
    }
    else {
        if (isProd) {
            curSpaceCode = isWebmail ? surveySpaceCode_web_new : surveySpaceCode_web_old;
        }
        else {
            curSpaceCode = surveySpaceCode_dev;
        }
    }
    return curSpaceCode;
};
const SurveySpace = () => {
    const fetchAdConfig = useCallback(debounce(async () => {
        try {
            const curSpaceCode = getSpaceCode();
            if (!curSpaceCode)
                return;
            const res = await advertApi.fetchConfig(curSpaceCode);
            const { success, data, message } = res;
            if (!success) {
                console.log('接口获取调查问券广告失败', message);
                return;
            }
            if (data) {
                const { itemList } = data;
                if (itemList === null || itemList === void 0 ? void 0 : itemList.length) {
                    const { advertResourceList } = itemList[0];
                    if (advertResourceList === null || advertResourceList === void 0 ? void 0 : advertResourceList.length) {
                        const { content } = advertResourceList[0];
                        const { clickContent } = content;
                        if (clickContent) {
                            try {
                                const surveyConfig = JSON.parse(clickContent);
                                const { surveyId } = surveyConfig;
                                if (surveyId) {
                                    if (getPopupCount(surveyId) >= MAX_POPUP_COUNT) {
                                        return;
                                    }
                                    const currentUser = systemApi.getCurrentUser();
                                    if (!currentUser)
                                        return;
                                    surveyConfig.query = Object.assign(Object.assign({}, surveyConfig.query), { uid: currentUser.id, orgName: currentUser.company || '' });
                                    console.log('surveyConfigsurveyConfig', surveyConfig);
                                    loadSDK(surveyConfig, currentUser.id);
                                }
                            }
                            catch (error) {
                                console.log('解析广告配置失败', error);
                            }
                        }
                    }
                }
            }
        }
        catch (error) {
            console.log('获取调查问券广告失败', error);
        }
    }, 2000), []);
    const showSurvey = (config) => {
        (window === null || window === void 0 ? void 0 : window._dw) &&
            _dw('checkUser', {
                complete(result) {
                    if (result.status) {
                        console.log('当前用户可以答题');
                        if (config === null || config === void 0 ? void 0 : config.surveyId) {
                            incrementPopupCount(config.surveyId);
                        }
                        setTimeout(() => {
                            _dw('open');
                        }, 500);
                    }
                    else {
                        console.log('当前用户不可答题');
                    }
                },
            });
    };
    const loadSDK = (config, id) => {
        window.localStorage.setItem('dw_clientId', id);
        if (window === null || window === void 0 ? void 0 : window._dw) {
            _dw('updateConfig', config);
            showSurvey(config);
            return;
        }
        (function (w, d, n) {
            w[n] =
                w[n] ||
                    function () {
                        return (w[n].queue = w[n].queue || []).push(arguments);
                    };
            const j = d.createElement('script');
            j.async = true;
            j.src = 'https://nos.netease.com/qiyukf/web-survey-js-sdk/js/sdk.js';
            d.body.appendChild(j);
            j.onload = a => {
                if (window === null || window === void 0 ? void 0 : window._dw) {
                    _dw('setConfig', config);
                    showSurvey(config);
                }
            };
        })(window, document, '_dw');
    };
    useEffect(() => {
        console.log('initFetch');
        fetchAdConfig();
    }, []);
    return React.createElement(React.Fragment, null);
};
export default SurveySpace;
